import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, Ensino } from './types';

export const INITIAL_STATE: Ensino = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Ensino {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENSINO_REQUEST: {
				break;
			}
			case Types.ENSINO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ENSINO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
